document.querySelectorAll('[data-cn-root]').forEach((root) => {
  // Galería: miniaturas, puntos y sincronía con el desplazamiento
  const track = root.querySelector('[data-cn-track]');
  const slides = track ? [...track.children] : [];
  const thumbs = root.querySelector('[data-cn-thumbs]');
  const dots = root.querySelector('[data-cn-dots]');
  if (slides.length > 1 && thumbs && dots) {
    slides.forEach((s, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Ver imagen ' + (i + 1));
      const img = s.querySelector('img');
      if (img) { const c = img.cloneNode(); c.removeAttribute('fetchpriority'); c.loading = 'lazy'; c.alt = ''; b.append(c); }
      else { b.innerHTML = s.innerHTML; }
      b.addEventListener('click', () => track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' }));
      thumbs.append(b);
      dots.append(document.createElement('span'));
    });
    const mark = (i) => {
      [...thumbs.children].forEach((t, j) => t.setAttribute('aria-current', j === i));
      [...dots.children].forEach((d, j) => d.classList.toggle('is-on', j === i));
    };
    mark(0);
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) mark(slides.indexOf(e.target)); }), { root: track, threshold: 0.6 });
    slides.forEach((s) => io.observe(s));
  }
  // Cantidad
  const q = root.querySelector('input[name="quantity"]');
  if (q) root.querySelectorAll('[data-cn-qty]').forEach((b) => b.addEventListener('click', () => {
    q.value = Math.min(10, Math.max(1, (parseInt(q.value, 10) || 1) + Number(b.dataset.cnQty)));
  }));
  // Precio según variante
  const price = root.querySelector('[data-cn-price]');
  root.querySelectorAll('input[name="id"][type="radio"]').forEach((r) => r.addEventListener('change', () => { if (price) price.textContent = r.dataset.price; }));
});

// Barra fija en móvil: aparece cuando el botón principal sale de pantalla y se oculta en la llamada final
(() => {
  const sticky = document.querySelector('[data-cn-sticky]');
  const cta = document.querySelector('[data-cn-main-cta]');
  if (!sticky || !cta) return;
  const final = document.querySelector('.cn-final');
  let ctaOut = false, finalIn = false;
  const upd = () => {
    const on = ctaOut && !finalIn;
    sticky.classList.toggle('is-on', on);
    sticky.setAttribute('aria-hidden', String(!on));
    const b = sticky.querySelector('button');
    if (b) b.tabIndex = on ? 0 : -1;
  };
  new IntersectionObserver(([e]) => { ctaOut = !e.isIntersecting && e.boundingClientRect.top < 0; upd(); }).observe(cta);
  if (final) new IntersectionObserver(([e]) => { finalIn = e.isIntersecting; upd(); }).observe(final);
})();
